const DISH_CERTAINTY_FILTER = {
  HIGH_CERTAINTY: {
    label: 'High',
    value: 'HIGH_CERTAINTY',
  },
  LOW_CERTAINTY: {
    label: 'Low',
    value: 'LOW_CERTAINTY',
  },
}

export default DISH_CERTAINTY_FILTER
